export default __webpack_public_path__ + "static/media/bg3.c775e086.jpg";